import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { media } from "../../data/navigationData";
import SEO from "../../components/SEO";
import ScrollDepthTracker from "../../components/ScrollDepthTracker";

export default function GordonResearchConference() {
  const gordonResearchConferenceSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Gordon Research Conference: Stroke drug breakthrough for patients",
    "url": "https://www.thrombio.com.au/media/gordonresearch",
    "mainEntity": {
      "@type": "Organization",
      "name": "Thrombio",
      "url": "https://www.thrombio.com.au/",
      "logo": "https://www.thrombio.com.au/thromBioInvert.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@thrombio.com.au"
      },
      "sameAs": [
        "https://www.linkedin.com/company/thrombioholdings"
      ]
    },
    "about": {
      "@type": "MedicalEntity",
      "name": "Thrombio Media",
      "description": "Professor Shaun Jackson presented as a keynote speaker at a prestigious Gordon Research Conference in Barcelona, Spain"
    }
  };

  return (
    <>
      <SEO
        title="Gordon Research Conference: Professor Shaun Jackson presented as a keynote speaker"
        description="Professor Shaun Jackson presented as a keynote speaker at a prestigious Gordon Research Conference in Barcelona, Spain"
        keywords={['Gordon Research Conference', 'COVID19', 'Red Blood Cell Roadblocks', 'Stroke Research', 'Prof Shaun Jackson', 'Microcirculation', 'Microclots', 'Red cell aggregates', 'Stroke', 'TBO-309', 'Stroke recovery', 'Blood vessel blockage', 'Anti-clotting drug', 'Stroke treatment', 'Novel therapeutics', 'Anti-platelet', 'Clinical trial', 'Platelet inhibitor']}
        ogImage="/gordonresearchconference.png"
        schema={gordonResearchConferenceSchema}
      />
      <ScrollDepthTracker pageCategory="media" pageName="gordon-research-conference" />

      <div className="bg-primary">
        <div className="page-width px-6 md:px-20 pt-[18px] pb-8">
          <nav className="flex items-center gap-2 font-sans text-[2rem] font-normal leading-[2.3rem]" aria-label="Breadcrumb">
            <Link to="/media" className="text-white hover:text-primary-red transition-colors">
              Media
            </Link>
            <span className="mx-1 text-white">/</span>
            <span className="text-[#5C95A4]">Gordon Research Conference: Professor Shaun Jackson presents keynote speech</span>
          </nav>
        </div>

        <div className="page-width px-6 md:px-20 pt-24 pb-8">
          <img src="/gordon-research-logo.png" alt="Gordon Research Conference Logo" className="max-h-[250px] md:h-[300px]" />
        </div>

        <div className="page-width px-6 md:px-20 pb-16">
          <div className="flex flex-col md:flex-row gap-20 mb-6">
            <div className="md:w-1/2 lg:w-23/5 order-2 md:order-1">
              <p className="text-white font-sans text-[2.2rem] leading-[3.4rem] tracking-wide">
                <div>ThromBio Founder & Director, <span class="underline hover:text-[#DA0912]"><Link to="/leadership/shaun-jackson">Professor Shaun Jackson</Link></span> recently delivered a plenary lecture at the Gordon Research Conferences (GRC) on Endothelium in Barcelona, Spain, presenting new insights from the Thrombosis Research Group into how blood clots form in the body’s smallest blood vessels. This is important clinically, as blockages forming in the smallest blood vessels (microvessels) in the human body, are common, and is a major reason why patients often don’t recover well after a heart attack or stroke. We now know that these same microvascular problems occur in many other diseases, including overwhelming septicaemia from blood infection, shock, following severe trauma, and most recently, in the life-threatening complications of COVID-19.</div>
              </p>
            </div>
            <div className="md:w-1/2 lg:w-3/5 flex items-start justify-end order-1 md:order-2">
              <img
                src="/shaun-gordon-research-conference-update-1.png"
                alt="Professor Shaun Jackson at Gordon Research Conference presenting new insights from the Thrombosis Research Group"
                className="max-w-full md:max-w-[100%] h-auto object-contain"
              />
            </div>
          </div>
          <div className="mb-16">
            <p className="text-white font-sans text-[2.2rem] leading-[3.4rem] tracking-wide mt-10">
              The lecture highlighted recent work published in Nature, including the discovery of a previously unrecognised clotting mechanism that may contribute to microvascular injury in conditions such as heart attack, stroke and sepsis. Shaun also discussed the role of dying platelets, neutrophil macroaggregates and the newly described EndoSeal mechanism in the microcirculation that not only prevents tissue bleeding, but can also leading to extensive small vessel obstruction.
            </p>
            <p className="text-white font-sans text-[2.2rem] leading-[3.4rem] tracking-wide mt-10">
              It was especially encouraging to see growing international interest in this work, with independent confirmation emerging from other laboratories. These findings are opening new conversations about the mechanisms that drive organ injury and the potential for future therapeutic strategies to better protect the microcirculation.
            </p>
            <p className="text-white font-sans text-[2.1rem] leading-[3.2rem] tracking-wide mt-10">
              <a target="_blank" rel="noreferrer" href="https://www.newcastleherald.com.au/story/9232857/stroke-breakthrough-with-thrombios-anti-clotting-drug-tbo-309/">
                Read about the <span class="text-[#DA0912]">Nature</span> paper <Link to="/media/nature"><span className="underline hover:text-[#DA0912]">here</span></Link>
              </a>
            </p>
          </div>
        </div>
        <SeriesNavigation
          items={media}
          currentSlug="gordonresearch"
          basePath="/media"
        />
      </div>
    </>
  );
}